@switch (variant()) {
  @case ('card') {
    <div class="app-skeleton__card" role="status" aria-busy="true" aria-label="Loading">
      <p-skeleton width="70%" height="1.25rem" borderRadius="8px" class="block" />
      <p-skeleton width="100%" height="0.875rem" borderRadius="6px" class="block" />
      <p-skeleton width="92%" height="0.875rem" borderRadius="6px" class="block" />
      <div class="app-skeleton__card-tags">
        <p-skeleton width="4.5rem" height="1.5rem" borderRadius="999px" />
        <p-skeleton width="5rem" height="1.5rem" borderRadius="999px" />
      </div>
      <div class="app-skeleton__card-meta">
        <p-skeleton width="85%" height="0.875rem" borderRadius="6px" />
        <p-skeleton width="60%" height="0.875rem" borderRadius="6px" />
      </div>
      <div class="app-skeleton__card-footer">
        <div class="flex flex-wrap gap-3">
          <p-skeleton width="4rem" height="0.875rem" borderRadius="6px" />
          <p-skeleton width="4rem" height="0.875rem" borderRadius="6px" />
          <p-skeleton width="5rem" height="0.875rem" borderRadius="6px" />
        </div>
        <p-skeleton shape="circle" size="2.25rem" />
      </div>
    </div>
  }
  @case ('detail-header') {
    <div class="app-skeleton__detail-header" role="status" aria-busy="true" aria-label="Loading header">
      <div class="flex flex-wrap items-center gap-2">
        <p-skeleton width="5rem" height="0.875rem" borderRadius="6px" />
        <span class="text-[var(--text-muted-on-light)] opacity-50" aria-hidden="true">&gt;</span>
        <p-skeleton width="8rem" height="0.875rem" borderRadius="6px" />
      </div>
      <div class="app-skeleton__detail-header-card">
        <p-skeleton width="min(100%, 28rem)" height="2.25rem" borderRadius="8px" class="block" />
        <div class="flex flex-col gap-3 mt-1">
          <div class="inline-flex items-center gap-2">
            <p-skeleton shape="circle" size="1.25rem" />
            <p-skeleton width="14rem" height="1rem" borderRadius="6px" />
          </div>
          <div class="inline-flex items-center gap-2">
            <p-skeleton shape="circle" size="1.25rem" />
            <p-skeleton width="11rem" height="1rem" borderRadius="6px" />
          </div>
        </div>
      </div>
    </div>
  }
  @case ('detail-body') {
    <div class="app-skeleton__detail-body mt-6" role="status" aria-busy="true" aria-label="Loading content">
      <div class="app-skeleton__detail-main lg:basis-[66%]">
        <div class="app-skeleton__section">
          <p-skeleton width="8rem" height="1.125rem" borderRadius="6px" class="mb-4 block" />
          <p-skeleton width="100%" height="0.75rem" borderRadius="6px" class="mb-2 block" />
          <p-skeleton width="100%" height="0.75rem" borderRadius="6px" class="mb-2 block" />
          <p-skeleton width="88%" height="0.75rem" borderRadius="6px" class="block" />
        </div>
        <div class="app-skeleton__section">
          <p-skeleton width="7rem" height="1.125rem" borderRadius="6px" class="mb-4 block" />
          <div class="app-skeleton__grid">
            @for (_ of [0, 1, 2, 3, 4, 5, 6, 7]; track $index) {
              <div class="app-skeleton__cell">
                <p-skeleton width="65%" height="0.65rem" borderRadius="4px" />
                <p-skeleton width="90%" height="0.875rem" borderRadius="6px" />
              </div>
            }
          </div>
        </div>
      </div>
      <aside class="app-skeleton__detail-side lg:basis-[33%]">
        <div class="app-skeleton__section">
          <p-skeleton width="9rem" height="1.125rem" borderRadius="6px" class="mb-4 block" />
          <div class="flex flex-wrap gap-3">
            <p-skeleton width="4.5rem" height="2rem" borderRadius="8px" />
            <p-skeleton width="4.5rem" height="2rem" borderRadius="8px" />
            <p-skeleton width="4.5rem" height="2rem" borderRadius="8px" />
          </div>
        </div>
        <div class="app-skeleton__section">
          <p-skeleton width="6rem" height="1.125rem" borderRadius="6px" class="mb-4 block" />
          <p-skeleton width="70%" height="0.875rem" borderRadius="6px" class="mb-3 block" />
          <div class="flex flex-wrap gap-2">
            <p-skeleton width="3.5rem" height="1.5rem" borderRadius="999px" />
            <p-skeleton width="4rem" height="1.5rem" borderRadius="999px" />
          </div>
        </div>
      </aside>
    </div>
  }
  @case ('list-items') {
    <div class="app-skeleton__list px-1 py-2" role="status" aria-busy="true" aria-label="Loading files">
      @for (_ of listRepeatIndices(); track $index) {
        <div class="app-skeleton__list-row">
          <p-skeleton shape="circle" size="1.25rem" />
          <p-skeleton width="100%" height="1rem" borderRadius="6px" class="min-w-0 flex-1 block" />
        </div>
      }
    </div>
  }
  @case ('table') {
    <div class="app-skeleton__table" role="status" aria-busy="true" aria-label="Loading preview">
      <div class="app-skeleton__table-row app-skeleton__table-row--head">
        @for (_ of [0, 1, 2, 3]; track $index) {
          <p-skeleton height="0.75rem" borderRadius="4px" />
        }
      </div>
      @for (_ of [0, 1, 2, 3, 4]; track $index) {
        <div class="app-skeleton__table-row">
          @for (__ of [0, 1, 2, 3]; track $index) {
            <p-skeleton height="0.75rem" borderRadius="4px" />
          }
        </div>
      }
    </div>
  }
}
